import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';

import { AppComponent } from '../app.component';

@Component({
  selector: 'hub-graph',
  template: `<hub-sub-menu></hub-sub-menu><div [innerHTML]="iFrameContent"></div>`,
})

export class HubGraphComponent implements OnInit {
  @Input() panelId: number;
  hubId: number;
  iFrameContent: SafeHtml;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.route.params
      .subscribe((params: Params) => this.setGraphIFrame(Number(+params['hubid'])));
  }

  setGraphIFrame(hubID: number): void {
    this.hubId = hubID;
    AppComponent.SetTitle(`Hub ${hubID}`);
    this.iFrameContent = this.sanitizer.bypassSecurityTrustHtml(`<iframe
    src="https://monaghan.hubcontrols.com/d-solo/740PPkQik/hub-admin-link?refresh=15m&panelId=2&orgId=1&var-hubid=${hubID}"
    width="900"
    height="400"
    frameborder="1"></iframe>`);
  }

}
